import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroButton"] */ "/workspace/src/components/HomePageClientParts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/workspace/src/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CyclingTypewriterEffect"] */ "/workspace/src/components/ui/typewriter-effect.tsx");
